export enum TemperatureEnum {
  "F",
  "C",
}
